import { useContext } from "react";
import AuthContext from "./AuthContext.jsx";

/**
 * Reads the session from the nearest <AuthProvider>.
 *
 * Lives outside AuthContext.jsx so that module only exports components — mixing
 * a hook into it defeats React Fast Refresh for every screen that imports it.
 */
export default function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used inside <AuthProvider>");
  }
  return ctx;
}
